import createPdFTable from "./GerarPdfTable";
import image2 from "./base642";

export default function index(data) {
  var body;
  body = createPdFTable(data);


  var dd = {
    header: {
      columns: [
        {
          stack: [
            {
              // if you specify width, image will scale proportionally
              image: `data:image/jpeg;base64,${image2}`,
              width: 200,
              margin: [30, 20, 0, 0]
            }
          ]
        }
      ]
    },

    content: [body],

    footer: function (currentPage, pageCount) {
      return [{
        text: `Data: ${dataNew()}`,
        alignment: "center",
        margin: [20, 20, 0, 0]
      },
      { text: 'Página ' + currentPage.toString() + ' de ' + pageCount, alignment: 'right', margin: [0, 0, 20, 0] },
      ];
    },
    /*   footer: {
        columns: [
          {
            stack: [
              // second column consists of paragraphs
              {
                text: `Gerado por: Aleika Lwiza Alves Fonsêca `,
                alignment: "center"
              },
              {
                text: `Data: ${dataNew()}`,
                alignment: "center"
              },
              ,
              {
                text: `Página 1 de 2`,
                alignment: "right"
              }
            ],
            margin: [0, 20, 10, 10]
          }
        ]
      }, */
    pageMargins: [40, 110, 40, 80],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        margin: [0, 30, 0, 0],
        alignment: "center"
      },
      image: {
        width: 100,
        alignment: "center"
      },
      subHeader: {
        fontSize: 14,
        bold: false,
        margin: [0, 2, 0, 0],
        alignment: "center"
      },
      title: {
        fontSize: 16,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      tableExample: {
        margin: [5, 5, 0, 5]
      },
      tableHeader: {
        bold: true,
        fontSize: 13,
        color: "black"
      },
      lineTable: {
        margin: [0, 10, 0, 5]
      },
      subTitle: {
        fontSize: 14,
        bold: true,
        margin: [0, 15, 0, 10],
        alignment: "center"
      }
    },
    defaultStyle: {
      // alignment: 'justify',
    }
  };
  return new Promise((resolve, reject) => {
    resolve(dd);
  });
}

function dataNew() {
  var today = new Date();
  var day = today.getDate() + "";
  var month = today.getMonth() + 1 + "";
  var year = today.getFullYear() + "";
  var hour = today.getHours() + "";
  var minutes = today.getMinutes() + "";
  var seconds = today.getSeconds() + "";
  return (
    day.padStart(2, '0') +
    "/" +
    month.padStart(2, '0') +
    "/" +
    year +
    " " +
    hour.padStart(2, '0') +
    ":" +
    minutes.padStart(2, '0') +
    ":" +
    seconds.padStart(2, '0')
  );
}
